module.exports = __webpack_public_path__ + "static/img/convocatoriaONU_PRC0034051.37c3336.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/convocatoriaONU_PRC0034051.jpg
// module id = MgDU
// module chunks = 9